"use strict";
var BLEUUID_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEUUID = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLE_UUID_PADDING = '-0000-1000-8000-00805f9b34fb';
/**
 * BLE UUID
 */
let BLEUUID = BLEUUID_1 = class BLEUUID {
    constructor(buffer) {
        this._raw = buffer;
    }
    static fromBuffer(buffer, littleEndian) {
        if (littleEndian) {
            let swappedBuffer = new Uint8Array();
            for (let i = buffer.length - 1; i >= 0; i--) {
                swappedBuffer = core_1.BufferUtils.concatBuffer(swappedBuffer, new Uint8Array([buffer[i]]));
            }
            return new this(swappedBuffer);
        }
        else {
            return new this(buffer);
        }
    }
    static fromString(uuid) {
        let array = Uint8Array.from(uuid
            .replace(BLE_UUID_PADDING, '')
            .replace(/-/g, '')
            .split(/(..)/)
            .filter((a) => {
            return a !== '';
        })
            .map((hex) => {
            return Number(`0x${hex}`);
        }));
        if (uuid.startsWith('0000')) {
            array = array.slice(2);
        }
        return new this(array);
    }
    toBuffer() {
        return this._raw;
    }
    to128bit() {
        return BLEUUID_1.fromString(this.toString(8));
    }
    toString(byteLength, padding = true) {
        byteLength = byteLength !== null && byteLength !== void 0 ? byteLength : this._raw.byteLength;
        const bytes = [];
        for (const [, value] of this._raw.entries()) {
            bytes.push(value);
        }
        const UUID_PADDING = padding ? BLE_UUID_PADDING : '';
        if (byteLength === 2) {
            // 16 bit
            return ('0000' +
                bytes
                    .map((byte) => {
                    return byte.toString(16).padStart(2, '0');
                })
                    .join('') +
                UUID_PADDING);
        }
        else if (byteLength === 4) {
            // 32 bit
            return (bytes
                .map((byte) => {
                return byte.toString(16).padStart(2, '0');
            })
                .join('') + UUID_PADDING);
        }
        else if (byteLength === 16) {
            // 128 bit
            const hex = bytes.map((byte) => {
                return byte.toString(16).padStart(2, '0');
            });
            return (hex.splice(0, 4).join('') +
                '-' +
                hex.splice(0, 2).join('') +
                '-' +
                hex.splice(0, 2).join('') +
                '-' +
                hex.splice(0, 2).join('') +
                '-' +
                hex.join(''));
        }
        else {
            // Strange
            const hex = bytes.map((byte) => {
                return byte.toString(16).padStart(2, '0');
            });
            return hex.join('');
        }
    }
};
exports.BLEUUID = BLEUUID;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Uint8Array)
], BLEUUID.prototype, "_raw", void 0);
exports.BLEUUID = BLEUUID = BLEUUID_1 = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [Uint8Array])
], BLEUUID);
//# sourceMappingURL=BLEUUID.js.map